import { Divider, Grid } from '@mui/material';
import * as React from 'react';
import { app } from '../config/app';
import Logo from '../components/Logo';
import CircularProgress from '@mui/material/CircularProgress';



export default function Loading(props) {
  const user=props.user;
  console.log("Loading app...");
  //if (!user) return;
  return (
    <>
    <Grid container direction="column" alignItems="center" justifyContent="center" style={{ minHeight: '100vh' }}>
      <Grid item >
        <Logo width={250}/>
      </Grid>
      <Grid item style={{ marginTop: '30px' }}>
        
        <CircularProgress />
      </Grid>
    </Grid>
    </>
  );
}
